// extracted by mini-css-extract-plugin
export default {"v-application":"Table_v-application_TfsQn","text-h1":"Table_text-h1_AotAZ","text-h2":"Table_text-h2_RV14j","table":"Table_table_kB9QL","sticky_cells":"Table_sticky_cells__wbBI"};